import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";

class StructuredProductData extends PureComponent {
  static propTypes = {
    description: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    upc: PropTypes.string.isRequired,
    sku: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  };

  render() {
    const schemaData = JSON.stringify({
      "@context": "http://schema.org",
      "@type": "Product",
      aggregateRating: {},
      offers: {},
      brand: {
        "@type": "Brand",
        name: "Hatch",
        logo: "https://images.hatchbaby.com/webassets/hatch-baby-logo.png",
        url: "https://www.hatchbaby.com",
      },
      name: `${this.props.name}`,
      description: `${this.props.description}`,
      gtin13: `0${this.props.upc}`,
      sku: `${this.props.sku}`,
      image: `${this.props.image}`,
      url: `${this.props.url}`,
    });

    return (
      <Helmet
        script={[
          {
            type: "application/ld+json",
            innerHTML: schemaData,
          },
        ]}
      />
    );
  }
}

export default StructuredProductData;
